<template>
  <div class="container">
    <slot name="header" />
    <v-card class="card">
      <div>
        <slot />
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PageContainer"
};
</script>
<style lang="scss">
.card {
  position: relative;
  padding: $spacing * 3;
}
</style>
